// extracted by mini-css-extract-plugin
export var actions = "_md-d";
export var benefitCard = "_md-a";
export var benefitIcon = "_md-b";
export var benefitLabel = "_md-c";
export var benefits = "_md-9";
export var bodyText = "_md-8";
export var closeButton = "_md-2";
export var content = "_md-3";
export var eyebrow = "_md-4";
export var heading = "_md-5";
export var image = "_md-f";
export var imagePanel = "_md-e";
export var modal = "_md-0";
export var shell = "_md-1";
export var title = "_md-6";
export var titleOffer = "_md-7";